import { Input, Output, EventEmitter, HostBinding, Directive } from "@angular/core";

@Directive()
export abstract class DodoBaseButtonComponent {
	@Input() color;
	@Input() height = 40;
	@Input() radius = 3;
	@Input()
	disabled = false;

	@Output() clicked = new EventEmitter();

	public shadowHeight = 3;

	constructor() {}

	public buttonClicked(event: Event) {
		event.stopPropagation();
		if (!this.disabled) {
			this.clicked.emit(event);
		}
	}
}
